const config = {
  BREVO_API_KEY: process.env.REACT_APP_BREVO_API_KEY || "",
};

export default config;
